import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
  <span class="created-by">
  Copyright &copy; 2015-2023 <b><a href="#" target="_blank">Novar Flex</a>.</b> All rights reserved
  </span>
    <div class="socials">
      <a href="#" target="_blank"><i class="fa fa-globe" style="font-size:20px"> Novar Flex Digital</i></a>
    </div>
  `,
})
export class FooterComponent {
}
